import request from '@/utils/request'

/**
 * 获取出口出库列表
 * @param {*} data 
 * @returns 
 */
export const getCKCKList = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/ckck/list`,
    data: data
})

/**
 * 获取出口证列表
 * @param {*} data 
 * @returns 
 */
 export const getJKZList = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/ckck/selectCkhczmList`,
    data: data
})
/**
 * 获取运输证列表
 * @param {*} id 
 * @param {*} data 
 * @returns 
 */
 export const getYSZList = (id, data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/ckck/selectYszList/${id}`,
    data: data
})

/**
 * 根据出口证主键查询出口证等信息
 * @param {*} id 
 * @returns 
 */
 export const getJKZ = (id) => request({
    method: 'get',
    url: `/yzdservice/enterprise/dwCk/ckck/selectCkhczById/${id}`
})
/**
 * 获取出口出库详情
 * @param {*} id 
 * @returns 
 */
 export const getCKCK = (id) => request({
    method: 'get',
    url: `/yzdservice/enterprise/dwCk/ckck/detail/${id}`
})


/**
 * 新增/编辑出口出库
 * @param {*} data 
 * @returns 
 */
export const addOrUpdSaveCKCK = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/ckck/addOrUpdSave`,
    data: data
})


/**
 * 删除出口出库
 * @param {*} data 
 * @returns 
 */
export const deleteCKCK = (id) => request({
    method: 'delete',
    url: `/yzdservice/enterprise/dwCk/ckck/remove/${id}`
})

/**
 * （变更保存前）校验库存是否为负数
 * @param {*} data 
 * @returns 
 */
export const changePdkc = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/ckck/changePdkcByCkck`,
    data
})
/**
 * 变更出口出库
 * @param {*} data 
 * @returns 
 */
export const saveChangeApply = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/ckck/saveChangeApply`,
    data
})

/**
 * 导出
 * @param {*} data 
 * @returns 
 */
export const excelwriter = (data) => request({
    method: 'post',
    url: `/yzdservice/enterprise/dwCk/ckck/excelwriter`,
    data,
    responseType: 'blob'
})

